// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { tasksAndDecisionsPlugin } from '@atlaskit/editor-plugin-tasks-and-decisions';
export type {
	TasksAndDecisionsPlugin,
	TasksAndDecisionsPluginDependencies,
	TaskDecisionPluginOptions,
	TasksAndDecisionsPluginOptions,
	TaskAndDecisionsSharedState,
	TaskDecisionListType,
	AddItemTransactionCreator,
} from '@atlaskit/editor-plugin-tasks-and-decisions';
